<template>
  <div class="flex flex-col items-center md:flex-row md:space-x-4">
    <div class="mb-8 flex space-x-3 md:mb-0">
      <NuxtLink
        v-for="(link, i) in shareLinks"
        :key="i"
        class="group relative mx-1.5 box-border flex h-14 w-14 flex-shrink-0 items-center justify-center rounded-full border border-white lg:mx-0"
        target="_blank"
        :to="link.url"
        @click="handleClick(link.label)">
        <span class="sr-only">{{ link.label }}</span>
        <component
          :is="`Icon${link.icon}`"
          class="h-5" />
        <span
          class="bg-pink-blue absolute inset-[-1px] rounded-full opacity-0 mix-blend-multiply transition-opacity duration-200 group-hover:opacity-100" />
      </NuxtLink>
    </div>

    <BlogButtonCopy
      :url="url"
      type="dark"
      @click="handleClick('Copy link share')" />
  </div>
</template>

<script setup lang="ts">
  import { useRoute } from 'vue-router'
  import { useRuntimeConfig } from '#app'
  import { useNuxtApp } from '#imports'

  import getShareLinks from '~/utils/urls'

  const runtimeConfig = useRuntimeConfig()
  const route = useRoute()
  const { $event } = useNuxtApp()

  const url = runtimeConfig.public.siteUrl + route.path
  const shareLinks = getShareLinks(url)

  function handleClick(linkLabel: string) {
    $event('Sharing', { props: { [linkLabel]: route.path } })
  }
</script>
